/**
 * Beu admin — AI overview (cost ledger) API. Admin-only endpoints under
 * /api/v2/admin/ai; the backend refuses sales reps and salon users.
 */
import siteSetting from '../config/env';

const apiV2Url = siteSetting.api.v2;

function authHeader() {
  return { 'Content-Type': 'application/json', accessToken: localStorage.getItem('accessToken') || '' };
}

async function handle(response) {
  const data = await response.json().catch(() => null);
  if (!response.ok || !data || data.statusCode !== 1) {
    const msg = (data && (data.error?.responseMessage || data.message || data.error?.message)) || response.statusText || 'Request failed';
    throw new Error(msg);
  }
  return data.responseData;
}

export function aiQuery(params) {
  const q = new URLSearchParams();
  Object.entries(params || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') q.set(k, v); });
  const s = q.toString();
  return s ? `?${s}` : '';
}

async function getOverview(month) {
  return handle(await fetch(`${apiV2Url}admin/ai/overview${aiQuery({ month })}`, { headers: authHeader() }));
}

async function getSalon(salonId, { month, page, limit, kind } = {}) {
  return handle(await fetch(`${apiV2Url}admin/ai/salons/${encodeURIComponent(salonId)}${aiQuery({ month, page, limit, kind })}`, { headers: authHeader() }));
}

/** Reads conversation content: the backend logs every call (adminaccesslogs). */
async function getSession(kind, id, reason) {
  return handle(await fetch(`${apiV2Url}admin/ai/sessions/${encodeURIComponent(kind)}/${encodeURIComponent(id)}${aiQuery({ reason })}`, { headers: authHeader() }));
}

/** CSV endpoints need the accessToken header, so fetch then save. */
async function downloadCsv(path, filename) {
  const res = await fetch(`${apiV2Url}admin/ai/${path}`, { headers: authHeader() });
  if (!res.ok) throw new Error('Export failed');
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const adminAiService = {
  getOverview,
  getSalon,
  getSession,
  exportOverviewCsv: (month) => downloadCsv(`overview.csv${aiQuery({ month })}`, `beu-ai-overview-${month || 'current'}.csv`),
  exportEventsCsv: (month) => downloadCsv(`events.csv${aiQuery({ month })}`, `beu-ai-events-${month || 'current'}.csv`),
  exportSalonEventsCsv: (salonId, month) => downloadCsv(`salons/${encodeURIComponent(salonId)}/events.csv${aiQuery({ month })}`, `beu-ai-events-${salonId}-${month || 'current'}.csv`)
};

export default adminAiService;
